import React from "react";
import Header from "../../../Components/Header";
import ClientDetailsOmsComp from "../../../Components/OMS/ClientDetailsOms/ClientDetailsOmsComp";
import PreviousObjectionList from "../../../Components/OMS/ClientDetailsOms/PreviousObjectionList";
import RejectionTypeComp from "../../../Components/OMS/ClientDetailsOms/RejectionTypeOms";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import { OMSSERVICES } from "../../../Configuration/Telecaller_URl";

function ClientDetailsOms() {
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
  }

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="omspage">
          <ClientDetailsOmsComp
            URL={OMSSERVICES.OMS_CLIENT_DETAILS}
            mainType={"Retail"}
          />
          <RejectionTypeComp
            URL={{
              addObjections: OMSSERVICES.ADD_OBJECTION,
              getObjections: OMSSERVICES.GET_OBJECTIONS,
              saveRejections: OMSSERVICES.SAVE_REJECTION,
            }}
            mainType={"Retail"}
          />
          <PreviousObjectionList
            URL={OMSSERVICES.PRIVIOUS_OBJECTION}
            mainType={"Retail"}
          />
        </div>
      </main>
    </>
  );
}

export default ClientDetailsOms;
